import React, { useEffect, useState, useRef } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import SearchForm from "./SearchForm";
import useDocumentTitle from '../../hooks/useDocumentTitle'
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-hot-toast';
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { holidaysearchresult, clearHolidayData, getavailableDestination } from './HolidaySlice';
import { Filter, Search } from 'lucide-react';
import HolidayFilter from './HolidayFilter';
import PackageCard from './PackageCard';
export default function SearchResult() {
    useDocumentTitle('Holiday Search');
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const destination = searchParams.get("cityname");
    const departuredate = searchParams.get("checkin_date");
    const [budget, setBudget] = useState([14625, 155365]);
    const [duration, setDuration] = useState([2, 20]);
    const [searchData, setSearchData] = useState(null);
    const [modifyFormData, setModifyFormData] = useState(null);
    const [apiData, setApiData] = useState(null);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [SearchId, seSearchId] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [query, setQuery] = useState(searchParams.get('cityname') || "");
    const [showSuggest, setShowSuggest] = useState(false);
    let postData = {
        customer_id: 0
    }
    const parseSearchParams = () => {
        const searchParams = new URLSearchParams(location.search);
        return {
            city: decodeURIComponent(searchParams.get('cityname') || ''),
            cityCode: decodeURIComponent(searchParams.get('cityCode') || ''),
            countryName: decodeURIComponent(searchParams.get('countryName') || ''),
            departuredate: searchParams.get('checkin_date') || '',
            totalAdults: parseInt(searchParams.get('adults') || '1', 10),
            totalChildren: parseInt(searchParams.get('childs') || '0', 10),

        };
    };

    const SearchHolidayData = async (payload) => {
        try {
            setLoading(true)
            dispatch(clearHolidayData())
            const response = await dispatch(holidaysearchresult(payload)).unwrap();
            setResults(response.data.data)
            seSearchId(response.data?.SearchId)
            setLoading(false)
            if (!response?.data?.success) {
                setLoading(false)
                toast.error(response?.data?.message, { autoClose: 3000 });
                // navigate(`/hotel`);
            }
        } catch (err) {
            console.error("Hotel search or fetch result failed:", err);
        }
    };

    const fetchDestination = async () => {
        try {
            const response = await dispatch(
                getavailableDestination({ postData })
            ).unwrap();
            const Resultdata = response.data;

            if (Resultdata.status.success) {
                setSuggestions(Resultdata.data);
            }
        } catch (error) {
            toast.error('Unbale to load destination', { autoClose: 3000 });
        }
    }

    useEffect(() => {
        fetchDestination()
        const parsedData = parseSearchParams();
        setSearchData(parsedData);
        setModifyFormData(parsedData);
        const generatedApiData = generateAPIDataFromParams(parsedData);
        setApiData(generatedApiData);
        SearchHolidayData(generatedApiData)

    }, [location.search]);
    const filteredSuggestions = suggestions.filter(item =>
        item.name.toLowerCase().includes(query.toLowerCase())
    );
    const currencyRef = useRef(null);

    const handleCitySelect = (city) => {
        const formData = parseSearchParams();

        const params = new URLSearchParams({
            cityname: encodeURIComponent(city.name),
            checkin_date: formData.departuredate,
            adults: 1,
            childs: 0,
            cityCode: city.cityCode.toString(),
        });
        window.location.href = `/Holidays/Search?${params.toString()}`;
        setShowSuggest(false);
    };

    const handleShowHotels = (e) => {
        e.preventDefault();
        const formData = parseSearchParams();
        if (!formData.city) {
            toast.error('Please select a city');
            return false;
        }

        // if (!travelDate) {
        //   toast.error('Please select Departure dates');
        //   return false;
        // }

        const params = new URLSearchParams({
            cityname: encodeURIComponent(formData.city),
            checkin_date: formData.departuredate,
            adults: 1,
            childs: 0,
            cityCode: formData.cityCode.toString(),
        });

        window.location.href = `/Holidays/Search?${params.toString()}`;
        return false;
    };

    const generateAPIDataFromParams = (parsedData) => {
        return {
            searchData: {
                isApiSearch: true,
                searchQuery: {
                    searchCriteria: {
                        dest_city: parsedData.city || null,
                        dest_city_id: parsedData.cityCode,
                        dest_countryName: parsedData.countryName,
                        adults: 1,
                        children: 0,
                        infant: "0",
                        childwob: "0"
                    },
                    DepartureCriteria: {
                        dep_city: null,
                        dep_city_id: null,
                        dep_countryName: null,
                        checkinDate: new Date(),//parsedData.departuredate || new Date(),
                        nights: "1"
                    },
                    searchPreferences: {
                        packageThemes: null,
                        hotelStars: "1,2,3,4,5"
                    },
                    currency: {
                        CurrencyRate: "1.000000",
                        CurrencyTitle: "INR",
                        CurrencyId: 1
                    }
                }
            }
        };
    };
    const priceBounds = React.useMemo(() => {
        if (!results?.length) return [0, 0];

        const allPrices = results.flatMap(pkg =>
            pkg.categories?.map(c => Number(c.finalPrice)) || []
        );

        return [
            Math.min(...allPrices),
            Math.max(...allPrices)
        ];
    }, [results]);
    const durationBounds = React.useMemo(() => {
        if (!results?.length) return [1, 20];

        const durations = results.map(r =>
            Number(r.PackageDuration)
        );

        return [
            Math.min(...durations),
            Math.max(...durations)
        ];
    }, [results]);

    const [filters, setFilters] = React.useState({
        priceRange: [0, 0],
        durationRange: [1, 20],
        flightType: "all", // all | with | without
        depCities: [],
        desCities: [],
        hotelStars: [],
        selectedThemes: [],
        selectedInclusions: [],
        sortBy: ""
    });
    React.useEffect(() => {
        setFilters(prev => ({
            ...prev,
            priceRange: priceBounds
        }));
    }, [priceBounds]);
    // const [filteredResults, setFilteredResults] = useState([]);
    const filteredResults = React.useMemo(() => {
        if (!results?.length) return [];

        let data = [...results];

        // PRICE FILTER
        data = data.filter(pkg => {
            const minPrice = Math.min(
                ...(pkg.categories?.map(c => Number(c.finalPrice)) || [0])
            );

            return (
                minPrice >= filters.priceRange[0] &&
                minPrice <= filters.priceRange[1]
            );
        });

        // DURATION FILTER
        data = data.filter(pkg => {
            const nights = Number(pkg.PackageDuration || 0);
            return (
                nights >= filters.durationRange[0] &&
                nights <= filters.durationRange[1]
            );
        });

        // FLIGHT FILTER
        if (filters.flightType !== "all") {
            data = data.filter(pkg => {
                const hasFlight = pkg.inclusion_names
                    ?.toLowerCase()
                    .includes("flight");

                return filters.flightType === "with"
                    ? hasFlight
                    : !hasFlight;
            });
        }

        // DEPARTURE CITY FILTER
        if (filters.depCities.length > 0) {
            data = data.filter(pkg =>
                filters.depCities.includes(pkg.dep_city_name)
            );
        }

        // DESTINATION CITY FILTER
        if (filters.desCities.length > 0) {
            data = data.filter(pkg =>
                filters.desCities.includes(pkg.des_city_name)
            );
        }

        // STAR RATING FILTER
        if (filters.hotelStars.length > 0) {
            data = data.filter(pkg =>
                filters.hotelStars.includes(String(pkg.star))
            );
        }

        // THEME FILTER
        if (filters.selectedThemes.length > 0) {
            data = data.filter(pkg => {
                const themes = pkg.theme_names
                    ?.split(",")
                    .map(t => t.trim());

                return themes?.some(t =>
                    filters.selectedThemes.includes(t)
                );
            });
        }

        // INCLUSION FILTER
        if (filters.selectedInclusions.length > 0) {
            data = data.filter(pkg => {
                const inclusions = pkg.inclusion_names
                    ?.split(",")
                    .map(i => i.trim());

                return filters.selectedInclusions.every(i =>
                    inclusions?.includes(i)
                );
            });
        }

        // SORTING
        data.sort((a, b) => {
            const minA = Math.min(...a.categories.map(c => Number(c.finalPrice)));
            const minB = Math.min(...b.categories.map(c => Number(c.finalPrice)));

            switch (filters.sortBy) {
                case "price_low":
                    return minA - minB;
                case "price_high":
                    return minB - minA;
                case "duration":
                    return Number(a.PackageDuration) - Number(b.PackageDuration);
                default:
                    return 0;
            }
        });

        return data;
    }, [results, filters]);
    const LoadingSkeleton = () => (
        <div className="space-y-4">
            {[...Array(6)].map((_, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md p-4 animate-pulse">
                    <div className="flex">
                        <div className="w-1/4 h-48 bg-gray-300 rounded-lg"></div>
                        <div className="w-3/4 pl-4">
                            <div className="h-6 bg-gray-300 rounded w-3/4 mb-4"></div>
                            <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
                            <div className="h-4 bg-gray-300 rounded w-2/3 mb-4"></div>
                            <div className="flex space-x-2 mb-4">
                                <div className="h-6 bg-gray-300 rounded w-16"></div>
                                <div className="h-6 bg-gray-300 rounded w-16"></div>
                                <div className="h-6 bg-gray-300 rounded w-16"></div>
                            </div>
                            <div className="flex justify-between">
                                <div className="h-8 bg-gray-300 rounded w-32"></div>
                                <div className="h-10 bg-gray-300 rounded w-32"></div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );

    return (
        <>
            <div className="bg-gray-100 text-gray-800 relative min-h-screen">
                <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-1 mt-6 space-y-6">
                    {/* <SearchForm departuredate={departuredate} destination={destination} /> */}
                    <form onSubmit={handleShowHotels}>
                        <div className="relative w-full lg:w-[800px] mx-auto" ref={currencyRef}>
                            <div className="flex bg-white rounded-full overflow-hidden shadow-lg w-full">
                                {/* Destination */}
                                <div className="flex items-center flex-1">
                                    <div className="flex items-center px-4 text-gray-400">
                                        <Search size={20} />
                                    </div>

                                    <input
                                        type="text"
                                        value={query}
                                        onChange={(e) => {
                                            setQuery(e.target.value);
                                            setShowSuggest(true);
                                        }}
                                        onFocus={() => setShowSuggest(true)}
                                        placeholder="Your Dream Destination!"
                                        className="w-full py-4 outline-none text-gray-700 text-base"
                                    />
                                </div>
                                {/* Search Button */}
                                <button type='submit' className="bg-orange-500 hover:bg-orange-600 text-white px-10 font-semibold rounded-full">
                                    Search
                                </button>
                            </div>

                            {/* Suggestion box */}
                            {showSuggest && (
                                <div className="absolute left-0 right-0 mt-1 bg-white rounded-2xl shadow-xl z-50 ">

                                    {/* Header */}
                                    <div className="flex items-center gap-3 px-5 py-2 border-b">
                                        <div className="h-9 w-9 rounded-full border flex items-center justify-center text-gray-500">
                                            📍
                                        </div>
                                        <p className="font-semibold text-lg">
                                            Available <span className="font-normal">Holiday Destinations</span>
                                        </p>
                                    </div>

                                    {/* List */}
                                    <ul className="max-h-[260px] overflow-auto">
                                        {filteredSuggestions.length ? (
                                            filteredSuggestions.map((item, idx) => (
                                                <li
                                                    key={idx}
                                                    onClick={() => {
                                                        setQuery(item.name);
                                                        handleCitySelect(item);
                                                    }}
                                                    className="flex items-center gap-4 px-5 py-3 hover:bg-gray-50 cursor-pointer"
                                                >
                                                    <img
                                                        src={item.image || '/images/des-placeholder.png'}
                                                        alt={item.name}
                                                        className="h-12 w-12 rounded-lg object-cover"
                                                    />
                                                    <div className="flex flex-col text-left">
                                                        <span className="text-lg font-medium leading-tight">
                                                            {item.name}
                                                        </span>
                                                        <span className="text-sm text-gray-500">
                                                            {item.fullRegionName}
                                                        </span>
                                                    </div>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="px-5 py-4 text-gray-500">
                                                No destinations found
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </form>
                    <div className="bg-gray-50 min-h-screen font-sans text-gray-700">
                        <div className="bg-white p-4 shadow-sm mb-6">
                            <div className="max-w-7xl mx-auto">
                                <div className="mt-6">
                                    <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
                                        <span className="text-red-500 text-xl">✦</span> {searchData?.city} Tour Packages
                                    </h1>
                                    <p className="text-sm text-gray-500 mt-2 leading-relaxed">
                                        If you have ever felt that your holiday photos never quite capture what you felt at that moment, just wait until you take our {searchData?.city} tour packages...
                                        {/* <span className="text-blue-500 cursor-pointer ml-1 hover:underline">Read More</span> */}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* <div className="max-w-7xl mx-auto px-4 mb-8">
                            <div className="flex items-center gap-4 overflow-x-auto pb-4 scrollbar-hide">
                                <button className="p-2 bg-white rounded-full shadow-md text-gray-400 hover:text-gray-800 flex-shrink-0">
                                    <ChevronLeft size={20} />
                                </button>

                                {categories.map((cat, idx) => (
                                    <div key={idx} className="relative w-48 h-20 rounded-xl overflow-hidden flex-shrink-0 group cursor-pointer">
                                        <img src={cat.img} alt={cat.name} className="w-full h-full object-cover group-hover:scale-110 transition duration-500" />
                                        <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                                            <span className="text-white font-bold text-sm text-center px-2">{cat.name}</span>
                                        </div>
                                    </div>
                                ))}

                                <button className="p-2 bg-white rounded-full shadow-md text-gray-400 hover:text-gray-800 flex-shrink-0">
                                    <ChevronRight size={20} />
                                </button>
                            </div>
                        </div> */}

                        <div className="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row gap-6 pb-12">

                            <div className="w-full lg:w-1/4">
                                <HolidayFilter
                                    results={results}
                                    filters={filters}
                                    setFilters={setFilters}
                                    priceBounds={priceBounds}
                                    durationBounds={durationBounds}
                                    filteredResults={filteredResults}
                                />
                            </div>

                            <div className="w-full lg:w-3/4">

                                <div className="bg-white rounded-lg shadow-sm mb-4 flex overflow-hidden text-sm">
                                    {/* <button className="flex-1 py-3 px-4 bg-blue-50 text-blue-600 font-bold border-b-2 border-blue-500 flex items-center justify-center gap-1">
                                        Sort by <ChevronDown size={14} />
                                    </button>
                                    <button className="flex-1 py-3 px-4 hover:bg-gray-50 text-gray-600 font-medium">Duration</button>
                                    <button className="flex-1 py-3 px-4 hover:bg-gray-50 text-gray-600 font-medium flex items-center justify-center gap-1">
                                        Price <span className="text-xs text-blue-500">↓</span>
                                    </button> */}
                                    <button
                                        className="flex-1 py-3 px-4 hover:bg-gray-50 text-gray-600 font-medium"
                                        onClick={() => setFilters(p => ({ ...p, sortBy: 'duration' }))}
                                    >
                                        Duration
                                    </button>

                                    <button
                                        className="flex-1 py-3 px-4 hover:bg-gray-50 text-gray-600 font-medium flex items-center justify-center gap-1"
                                        onClick={() => setFilters(p => ({ ...p, sortBy: 'price_low' }))}
                                    >
                                        Price ↑
                                    </button>

                                    <button
                                        className="flex-1 py-3 px-4 hover:bg-gray-50 text-gray-600 font-medium flex items-center justify-center gap-1"
                                        onClick={() => setFilters(p => ({ ...p, sortBy: 'price_high' }))}
                                    >
                                        Price ↓
                                    </button>
                                </div>
                                {loading ? (
                                    <LoadingSkeleton />
                                ) : (
                                    <>
                                        {/* <div className="text-right text-xs text-gray-500 mb-4">Showing 10 Trips</div> */}

                                        <div className="space-y-6">
                                            {filteredResults.length > 0 ? (
                                                <>
                                                    {filteredResults && filteredResults.map((pkg) => (
                                                        <PackageCard key={pkg.id} pkg={pkg} SearchId={SearchId} />
                                                    ))}
                                                </>
                                            ) : (
                                                <>
                                                    <div className="text-center text-xl text-gray-500 mb-4">No package found</div>
                                                </>
                                            )}

                                        </div>
                                    </>
                                )}



                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
}
